import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate, Navigate } from 'react-router-dom'
import './index.css'
import COLORS from '../../colors'
import Header from '../Header'
import {ReactComponent as Trash} from '../../assets/trash.svg'
import { AuthContext } from '../../App.js'
import { getHostName } from '../../base.js'
import ModalEditQuantityNumber from '../ModalEditQuantityNumber'
import { Button, Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery, makeStyles }  from '@material-ui/core'
import { useSwipeable } from 'react-swipeable'
import { isMobile } from 'react-device-detect'

const useStyles = makeStyles((theme) => ({
 
	nameHead: {
		paddingTop:'0.6rem',
		paddingBottom:'0.6rem',
		padingRight: 0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
		width:'40%',
  	},
  	priceHead: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
		width:'20%',
  	},
	quantityHead: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
		width:'20%',
  	},
	removeHead: {
		padding:0,
		paddingLeft: '1rem',
		width: '10%',    
  	},
  	nameBody: {
		color: COLORS.blue,
		fontWeight: '700',
  	},
  	priceBody:{
		padding:0,
		color: COLORS.green,
		fontWeight: '700',
  	},
	quantityBody:{
		padding:0,
		color: COLORS.green,
		fontWeight: '700',
  	},
	removeBody: {
		padding:0,
  	},
	 
  }));
 
const Cart = ({ cid, cartItems }) => {
	const matches = useMediaQuery('(min-width:600px)')
  	const { generateQR, removeItemFromCart, setPageNumber, setPrevPage, signOut } = useContext(AuthContext)
  	const [ total, setTotal ] = useState(0)
	const [ article, setArticle ] = useState('')
	const [ popup, setPopup ] = useState(false)
	const params = useParams()
	const navigate = useNavigate()
	const classes = useStyles()
	 
	// setup ref for your usage
	const myRef = useRef();
	const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

	const handleLeftSwipe = () => {
			setPageNumber(5)
			setTimeout(() => {
				navigate(`/kekspos/${params.tid}/qr-artikl`)
			},0)
	}

	const handleRightSwipe = () => {
			if(cartItems.length>0){
				generateQR(total)
				setPageNumber(2)
				setTimeout(() => {
					navigate(`/kekspos/${params.tid}/qr-kod`)
				}, 0) 
			}
	}

	const refPassthrough = (el) => {
			// call useSwipeable ref prop with el
			handlers.ref(el)
			// set myRef el so you can access it yourself
			myRef.current = el
	}

	useEffect(() => {
		setPrevPage({prevPageNum:6})
		window.addEventListener('popstate', onBackButtonEvent)
		 
		return () => {
				window.removeEventListener('popstate', onBackButtonEvent);
		}
  	}, [])

	const onBackButtonEvent = (e) => {
			e.preventDefault()
			setPageNumber(5)
			setTimeout(() => {
				navigate(`/kekspos/${params.tid}/qr-artikl`)
			},0)
			 
	}

	useEffect(() => 
    {   
        const handleReload = async (e) => 
        {
            e.preventDefault()
            signOut(cid)
            setTimeout(() => window.location.assign(`/kekspos`, 0));
            window.removeEventListener('beforeunload', handleReload) 
            return false
         }

        window.addEventListener("beforeunload", handleReload)
         
        return () => 
        {    
            window.removeEventListener('beforeunload', handleReload) 
        }
  
  	}, [])
	 
	const handleEditQuantity = (item) => {
			console.log(item)
			setArticle(item)
			setPopup(true)
	}

  	const handleRemoveItem = (id) => {
			removeItemFromCart({items: cartItems, id:id})
	}

  	const handleTotal = () => {
		var totalAmount = 0
		for(let ele in cartItems){
				totalAmount += cartItems[ele].quantity*cartItems[ele].item.price
		}
		setTotal(totalAmount)
	}

  useEffect(() => {handleTotal()},[handleRemoveItem])

  return (
	<div className="cart" {...handlers} ref={refPassthrough}>
	  <ModalEditQuantityNumber 	popup={popup}
	  							editedItem={article}
								cartItems={cartItems}
								onClose={()=>setPopup(false)}
		/>
	  <Header pageNumber={6}/>
	  {cartItems.length!==0?(
	  <div className="cart-body">
		  	<div className="cart-table">
			  	<Table stickyHeader className={classes.table}
				  					style={{width:!isMobile?'35rem':'100%'}} 
				  					aria-label="sticky table" 
									size="small">
                    <TableHead style={{zIndex:popup?'-1':'1'}}>
                        <TableRow>
                            <TableCell className={classes.nameHead} component="td" scope="row">Proizvod</TableCell>
                            <TableCell className={classes.priceHead} component="td" scope="row" align="center">Cijena</TableCell>
							<TableCell className={classes.quantityHead} component="td" scope="row" align="right">Količina</TableCell>
                            <TableCell className={classes.removeHead} component="td" scope="row" align="right">Obriši</TableCell>
                        </TableRow>
                    </TableHead>
					<TableBody>
						{cartItems.map((item, id) => 
							<TableRow key={id} className="cart-tabel-row">
								<TableCell className={classes.nameBody}
											style={{maxWidth:!matches?'40vw':'5vw'}} 
											onClick={()=>handleEditQuantity(item)}
								><div style={{wordWrap:'break-word'}}>{item.item.name}</div></TableCell>
								<TableCell className={classes.priceBody}
											align="center" 
											onClick={()=>handleEditQuantity(item)}
								>{(item.item.price*item.quantity).toFixed(2)} EUR</TableCell>
								<TableCell className={classes.quantityBody}
											align="right" 
											onClick={()=>handleEditQuantity(item)}
								>{item.quantity} kom</TableCell>
								<TableCell className={classes.removeBody}
											align="right"
											onClick={() => handleRemoveItem(item.item.id)}
								><Trash style={{marginRight:'0.4rem', marginBottom:'-0.3rem'}}/></TableCell>
							</TableRow>)							 
						}
					</TableBody>
				</Table>
			</div>
			<div className="cart-total" style={{width:!isMobile?'55%':'90%'}}><span className="cart-total-txt">Ukupno: </span><span className="cart-total-subtxt">{total.toFixed(2)} EUR</span></div>
	  		<div className="cart-btns" style={{top:!matches?'80vh':'80vh'}}>
					<Button size="large"
							variant="contained"
							style={{color:COLORS.blue,
									borderTopColor:COLORS.blue,
									fontWeight:'600',
						    		width:!isMobile?'25rem':'90%',
									backgroundColor: '#fff',
									border:'2px solid #2F2F5B', 
									textTransform:'none',
									textDecoration:'none',
									marginBottom:'1rem',
									"&:hover": {
										backgroundColor:'#fff'
								  	} 
	   								}}
							component={Link}
							to={`/kekspos/${params.tid}/qr-artikl`}
							onClick={() => setPageNumber(5)}
					>DODAJ NOVI PROIZVOD</Button>
					<Button size="large"
							variant="contained"
							style={{color:"#fff",
									fontWeight:'600',
									width:!isMobile?'25rem':'90%',
									backgroundColor:COLORS.blue,
									textTransform:'none',
									textDecoration:'none',
									"&:hover": {
										backgroundColor:COLORS.blue
						  			} 
	   						}}
							component={Link}
							to={`/kekspos/${params.tid}/qr-kod`} 
							onClick={() => generateQR(total)}
					>KREIRAJ QR KOD</Button>
			</div>
		</div>
	  ):(
	    <div className="cart-body-warn">
		 	<div className="cart-warrning">Obrisali ste sve proizvode iz košarice, vratite se na listu artikala...</div>
		 	<Button size="large"
					variant="contained"
					style={{position:'fixed',
							top:'60vh',
							color:"#fff",
							fontWeight:'600',
							width:!isMobile?'25rem':'90%',
							backgroundColor:COLORS.blue,
							textTransform:'none',
							textDecoration:'none',
							"&:hover": {
								backgroundColor:COLORS.blue
						    } 
	   				}}
					component={Link}
					to={`/kekspos/${params.tid}/qr-artikl`}  
			 		onClick={() => setPageNumber(5)}
			>POVRATAK NA LISTU ARTIKALA</Button>
		</div>
	   )}
    </div>
  )
}

export default Cart
